<template>
  <div class="table-wrapper">
    <table>
      <caption class="visually-hidden">
        {{
          $t('TEMPLATE_EVENTS_REPORT.HEADER')
        }}
      </caption>
      <thead>
        <tr>
          <th>{{ $t('TEMPLATE_EVENTS_REPORT.TABLE.TEMPLATE') }}</th>
          <th>{{ $t('TEMPLATE_EVENTS_REPORT.TABLE.STATUS_QUEUED') }}</th>
          <th>{{ $t('TEMPLATE_EVENTS_REPORT.TABLE.STATUS_SENT') }}</th>
          <th>{{ $t('TEMPLATE_EVENTS_REPORT.TABLE.STATUS_DELIVERED') }}</th>
          <th>{{ $t('TEMPLATE_EVENTS_REPORT.TABLE.STATUS_FAILED') }}</th>
          <th>{{ $t('TEMPLATE_EVENTS_REPORT.TABLE.TOTAL') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in paginatedData"
          :key="index"
          :class="{ 'striped-row': index % 2 !== 0 }"
        >
          <td>{{ item.template_name || '—' }}</td>
          <td>{{ item.queued || 0 }}</td>
          <td>{{ item.sent || 0 }}</td>
          <td>{{ item.delivered || 0 }}</td>
          <td>{{ item.failed || 0 }}</td>
          <td>{{ item.total }}</td>
        </tr>
      </tbody>
    </table>

    <div class="pagination">
      <button @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">
        {{ $t('TEMPLATE_EVENTS_REPORT.PAGINATION.PREVIOUS') }}
      </button>
      <span>
        {{ $t('TEMPLATE_EVENTS_REPORT.PAGINATION.PAGE') }} {{ currentPage }}
        {{ $t('TEMPLATE_EVENTS_REPORT.COMMON.OF') }} {{ totalPages }}
      </span>
      <button
        @click="goToPage(currentPage + 1)"
        :disabled="currentPage === totalPages"
      >
        {{ $t('TEMPLATE_EVENTS_REPORT.PAGINATION.NEXT') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TemplateEventsReasonsTable',
  props: {
    templateEventsData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentPage: 1,
      perPage: 100,
    };
  },
  computed: {
    groupedData() {
      const groups = {};

      this.templateEventsData.forEach(msg => {
        const name = msg.template_name || '—';
        const status = msg.status;

        if (!groups[name]) {
          groups[name] = {
            template_name: msg.template_name,
            queued: 0,
            sent: 0,
            delivered: 0,
            failed: 0,
            total: 0,
          };
        }

        if (status === 'queued') groups[name].queued++;
        else if (status === 'sent') groups[name].sent++;
        else if (status === 'delivered') groups[name].delivered++;
        else if (status === 'failed') groups[name].failed++;

        if (
          status === 'queued' ||
          status === 'sent' ||
          status === 'delivered' ||
          status === 'failed'
        ) {
          groups[name].total++;
        }
      });

      return Object.values(groups).sort((a, b) => b.total - a.total);
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.groupedData.slice(start, start + this.perPage);
    },
    totalPages() {
      return Math.ceil(this.groupedData.length / this.perPage);
    },
  },
  methods: {
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
  },
};
</script>

<style scoped>
.table-wrapper {
  width: 100%;
  overflow-x: auto;
  max-height: 600px;
  overflow-y: auto;
  border: 1px solid #ddd;
}

table {
  width: 100%;
  border-collapse: collapse;
  min-width: 1000px;
}

thead {
  background-color: #2563eb;
  color: white;
}

th,
td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #eaeaea;
  word-break: break-word;
  vertical-align: top;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}

.striped-row {
  background-color: #f9f9f9;
}

a {
  color: #2563eb;
  text-decoration: underline;
}

.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 16px;
  align-items: center;
}

.pagination button {
  background-color: #2563eb;
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.pagination button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
